<template>
  <div class="page" v-if="currentUser">
    <SnackBar></SnackBar>
    <LoadingOverlay></LoadingOverlay>
    <AmazonLogin></AmazonLogin>
  </div>
</template>

<script>

export default {
  mounted() {},
  computed: {
    currentUser() {
      return window.localStorage.getItem('mm-platform-user');
    },
  },
  components: {
    SnackBar: () => import('components/common/SnackBar'),
    AmazonLogin: () => import('components/amazonLogin/'),
    LoadingOverlay: () => import('components/common/LoadingOverlay'),
  },
};
</script>
